import { LokasiIntelligenceIcon, LokasiTargetinIcon } from "@/assets/icons";
import {
  DEFAULT_PRODUCT,
  type Product,
  type ProductKey,
  ProductKeyEnum
} from "@/constants/products";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

// Logo per product. Add a new product here plus its entry in constants/products.
const PRODUCT_ICON: Record<ProductKey, JSX.Element> = {
  [ProductKeyEnum.INTELLIGENCE]: (
    <LokasiIntelligenceIcon className="w-[2.625rem] h-[2.625rem]" />
  ),
  [ProductKeyEnum.TARGETIN]: (
    <LokasiTargetinIcon className="w-[2.625rem] h-[2.625rem]" />
  )
};

type ProductSwitcherMenuProps = {
  /** Products the user's subscription gives access to */
  products: Product[];
  /** Called with the picked product; the parent opens its home route */
  onSelect: (product: Product) => void;
};

export const ProductSwitcherMenu = ({
  products,
  onSelect
}: ProductSwitcherMenuProps) => {
  return (
    <div className="flex flex-col gap-3 p-3" data-testid="product-menu">
      <span className="text-sm font-semibold text-txtHeading text-center">
        Select Product
      </span>
      <div className="flex items-center justify-center gap-[1.375rem]">
        {products.map((product) => {
          const isActive = product.key === DEFAULT_PRODUCT;
          return (
            <Button
              key={product.key}
              variant="ghost"
              data-testid={`product-item-${product.key}`}
              onClick={() => onSelect(product)}
              className={twMerge(
                "flex flex-col items-center gap-2.5 w-[91px] px-2 pt-3 pb-2 rounded-xl h-auto group",
                isActive ? "bg-teal-50" : "hover:bg-teal-50"
              )}
            >
              {PRODUCT_ICON[product.key]}
              <span
                className={twMerge(
                  "text-xs text-center",
                  isActive
                    ? "font-semibold text-teal-500"
                    : "font-normal text-txtHeading group-hover:text-teal-500"
                )}
              >
                {product.label}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default ProductSwitcherMenu;
